import { motion } from "framer-motion";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import BookingForm from "@/components/site/BookingForm";
import { MEDIA } from "@/lib/media";

export default function Book() {
  return (
    <div className="bg-ink min-h-screen">
      <Navbar />

      <section className="relative pt-40 pb-24 md:pt-52 md:pb-32 overflow-hidden" data-testid="book-hero">
        <div className="absolute inset-0">
          <img src={MEDIA.extHero} alt="" className="w-full h-full object-cover opacity-25" />
          <div className="absolute inset-0 bg-gradient-to-b from-ink/60 via-ink/80 to-ink" />
        </div>

        <div className="relative z-10 max-w-[1500px] mx-auto px-6 md:px-10">
          <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}>
            <span className="font-serif italic text-gold tracking-[0.25em] text-sm">Book An Inspection</span>
            <h1 className="font-display uppercase text-cream leading-[0.88] tracking-tight text-6xl md:text-8xl mt-4">
              Reserve Your <br /> <span className="text-gold">Inspection</span>
            </h1>
            <p className="text-cream/60 mt-6 max-w-xl leading-relaxed text-lg">
              Serving Cumming, GA and surrounding cities. Complete the form below and our team will
              confirm your luxury estate inspection the same day.
            </p>
          </motion.div>
        </div>
      </section>

      <section className="relative bg-ink pb-32">
        <div className="max-w-4xl mx-auto px-6 md:px-10">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9 }}
            className="border border-white/10 bg-surface p-8 md:p-14"
          >
            <BookingForm />
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
